import { FC, PropsWithChildren } from 'react';
import { TipAlign, Tooltip } from 'ui/tooltip';
import { CircleSpinner } from 'ui/spinner/CircleSpinner';
import { NegativeFillDiamond } from 'ui/icons/status/NegativeFillDiamond';
import { WarningFill16 } from 'ui/icons/aurora/16px/WarningFill16';
import { TriggerProps } from '../types';
import { StyledTriggerButton, ErrorTooltipContent } from './TriggerButton.styles';
import { getTriggerStyleProps } from './getTriggerStyle';

export const DATA_TEST = {
  button: 'queryBuilder-trigger-button',
};

export const TriggerButton: FC<PropsWithChildren<TriggerProps>> = ({
  children,
  hasError = false,
  hasWarning = false,
  innerRef,
  isDisabled = false,
  isEmpty = false,
  isGhost = false,
  isLoading = false,
  isReadOnly = false,
  onClick,
  tooltipContent,
  variant,
  ...props
}) => {
  const isTooltipEnabled = !!tooltipContent;
  const isErrorIconVisible = hasError && !isDisabled && !isReadOnly && !isGhost && !isLoading;
  const isWarningIconVisible = hasWarning && !hasError && !isGhost && !isLoading;
  const triggerStyleProps = getTriggerStyleProps({
    hasError,
    isDisabled,
    isEmpty,
    isGhost,
    hasWarning,
    isLoading,
    isReadOnly,
    variant,
  });

  return (
    <Tooltip
      align={TipAlign.Center}
      ContentComponent={hasError ? ErrorTooltipContent : undefined}
      isEnabled={isTooltipEnabled}
      isUsedOnButton
      tooltipContent={tooltipContent}
    >
      <StyledTriggerButton
        id="queryBuilder-trigger-button"
        onClick={(event) => {
          if (isDisabled || isReadOnly) return;
          onClick(event);
        }}
        type="button"
        ref={innerRef}
        {...triggerStyleProps}
        {...props}
        data-test={DATA_TEST.button}
      >
        {isWarningIconVisible && <WarningFill16 isColorInherited />}
        {isLoading && <CircleSpinner size={16} isColorInherited />}
        {!isLoading ? children : null}
        {isErrorIconVisible && <NegativeFillDiamond isColorInherited />}
      </StyledTriggerButton>
    </Tooltip>
  );
};
